// Single source of truth for the per-item static product pages. Both the
// router (App.js) and SEO_ROUTES/sitemap derive from this list, so the route
// set, the indexable URLs, and the sitemap can never drift apart. The service
// and deck sets are fixed (admins edit fields, not rows), so enumerating the
// slugs here is safe.
export type ProductPageSpec =
  | { slug: string; kind: "service"; key: string }
  | { slug: string; kind: "deck"; key: string }
  | { slug: string; kind: "bundle" };

export const PRODUCT_PAGES: readonly ProductPageSpec[] = [
  { slug: "digital-tarot-insight", kind: "service", key: "digital-tarot-insight" },
  { slug: "live-tarot", kind: "service", key: "live-tarot" },
  { slug: "live-psychic", kind: "service", key: "live-psychic" },
  { slug: "live-mediumship", kind: "service", key: "live-mediumship" },
  { slug: "in-person", kind: "service", key: "in-person" },
  { slug: "events", kind: "service", key: "events" },
  { slug: "tarot-corner", kind: "service", key: "tarot-corner" },
  { slug: "sacred-visit", kind: "service", key: "sacred-visit" },
  { slug: "guidance", kind: "deck", key: "guidance" },
  { slug: "mediumship", kind: "deck", key: "mediumship" },
  { slug: "bundle", kind: "bundle" },
];

/** The "/slug" path for a spec — the form used in routes and SEO_ROUTES. */
export function productPath(spec: ProductPageSpec): string {
  return `/${spec.slug}`;
}
